import api from "../api";

export const inspectionRoutesService = {
  // Get all inspection routes
  getInspectionRoutes: async (params = {}) => {
    try {
      const response = await api.post("/inspection-routes", params);
      return response;
    } catch (error) {
      console.error("Error fetching inspection routes:", error);
      throw error;
    }
  },

  // Get a specific inspection route
  getInspectionRoute: async (id) => {
    try {
      const response = await api.get(`/inspection-routes/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching inspection route:", error);
      throw error;
    }
  },

  // Create a new inspection route
  createInspectionRoute: async (data) => {
    try {
      const response = await api.post("/inspection-routes", data);
      return response;
    } catch (error) {
      console.error("Error creating inspection route:", error);
      throw error;
    }
  },

  // Update an inspection route
  updateInspectionRoute: async (id, data) => {
    try {
      const response = await api.put(`/inspection-routes/${id}`, data);
      return response;
    } catch (error) {
      console.error("Error updating inspection route:", error);
      throw error;
    }
  },

  // Delete an inspection route
  deleteInspectionRoute: async (id) => {
    try {
      const response = await api.delete(`/inspection-routes/${id}/destroy`);
      return response;
    } catch (error) {
      console.error("Error deleting inspection route:", error);
      throw error;
    }
  },

  // Get building managers for inspection routes
  getBuildingManagers: async () => {
    try {
      // Use the existing building managers endpoint from users controller
      const response = await api.get("/users/building-managers");
      return response;
    } catch (error) {
      console.error("Error fetching building managers:", error);
      throw error;
    }
  },

  // Get properties for an inspection route
  getInspectionRouteProperties: async (routeId) => {
    try {
      const response = await api.get(
        `/inspection-routes/${routeId}/properties`
      );
      return response;
    } catch (error) {
      console.error("Error fetching inspection route properties:", error);
      throw error;
    }
  },

  // Add property to inspection route
  addPropertyToRoute: async (routeId, propertyId) => {
    try {
      const response = await api.get(
        `/inspection-routes/${routeId}/property/${propertyId}/add`
      );
      return response;
    } catch (error) {
      console.error("Error adding property to inspection route:", error);
      throw error;
    }
  },

  // Remove property from inspection route
  removePropertyFromRoute: async (routeId, propertyId) => {
    try {
      const response = await api.delete(
        `/inspection-routes/${routeId}/property/${propertyId}/remove`
      );
      return response;
    } catch (error) {
      console.error("Error removing property from inspection route:", error);
      throw error;
    }
  },

  // Export inspection routes as CSV
  exportCSV: async (params = {}) => {
    try {
      const response = await api.post("/inspection-routes/export/csv", params, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.error("Error exporting CSV:", error);
      throw error;
    }
  },

  // Export inspection routes as PDF
  exportPDF: async (params = {}) => {
    try {
      const response = await api.post("/inspection-routes/export/pdf", params, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.error("Error exporting PDF:", error);
      throw error;
    }
  },

  // Get inspection route statistics
  getInspectionRouteStatistics: async () => {
    try {
      const response = await api.get("/inspection-routes/statistics");
      return response;
    } catch (error) {
      console.error("Error fetching inspection route statistics:", error);
      throw error;
    }
  },

  // Search inspection routes
  searchInspectionRoutes: async (query) => {
    try {
      const response = await api.get(`/inspection-routes/search?q=${query}`);
      return response;
    } catch (error) {
      console.error("Error searching inspection routes:", error);
      throw error;
    }
  },

  // Search properties for adding to inspection route
  searchProperties: async (query) => {
    try {
      const response = await api.get(
        `/properties/search?q=${encodeURIComponent(query)}`
      );
      return response.data.properties || [];
    } catch (error) {
      console.error("Error searching properties:", error);
      throw error;
    }
  },

  // Mock data for development/testing
  getMockInspectionRoutes: () => {
    return [
      {
        id: 1,
        name: "Central London Route",
        building_manager_id: 1,
        buildingManagerName: "John Smith",
      },
      {
        id: 2,
        name: "East London Route",
        building_manager_id: 2,
        buildingManagerName: "Sarah Wilson",
      },
      {
        id: 3,
        name: "North London Route",
        building_manager_id: 3,
        buildingManagerName: "Emma Davis",
      },
      {
        id: 4,
        name: "South London Route",
        building_manager_id: 4,
        buildingManagerName: "James Miller",
      },
      {
        id: 5,
        name: "West London Route",
        building_manager_id: 5,
        buildingManagerName: "Robert Taylor",
      },
    ];
  },

  // Mock building managers data
  getMockBuildingManagers: () => {
    return [
      { id: 1, full_name: "John Smith" },
      { id: 2, full_name: "Sarah Wilson" },
      { id: 3, full_name: "Emma Davis" },
      { id: 4, full_name: "James Miller" },
      { id: 5, full_name: "Robert Taylor" },
      { id: 6, full_name: "Michael Clark" },
      { id: 7, full_name: "Lisa Anderson" },
      { id: 8, full_name: "David Brown" },
      { id: 9, full_name: "Rachel Lee" },
      { id: 10, full_name: "Tom Wilson" },
    ];
  },
};
